export default {
    schedule_permission: { title: 'ผู้มีสิทธิ์ตั้งค่าตารางเรียน' },
    home: {
        welcome: 'ยินดีต้อนรับสู่ระบบสารสนเทศนักศึกษา',
        student: 'นักศึกษา',
        view_profile: 'ดูข้อมูลนักศึกษา',
        try_again: 'ลองอีกครั้ง',
        quick_menu: 'เมนูด่วน',
        quick_menu_subtitle: 'เข้าถึงบริการที่ใช้งานบ่อยได้จากที่นี่',
        student_information: 'ข้อมูลนักศึกษา',
        student_information_detail: 'ตรวจสอบข้อมูลส่วนตัวและข้อมูลการศึกษา',
        pre_registration_detail: 'วางแผนและลงทะเบียนล่วงหน้า',
        registration: 'ลงทะเบียนเรียน',
        graduate_registration: 'ลงทะเบียนบัณฑิตศึกษา',
        registration_detail: 'ลงทะเบียน เพิ่ม เปลี่ยน หรือถอนรายวิชา',
        timetable_detail: 'ดูรายวิชา ห้องเรียน และเวลาเรียน',
        exam_timetable_detail: 'ตรวจสอบวัน เวลา และห้องสอบ',
        payment_detail: 'ตรวจสอบและชำระค่าธรรมเนียมการศึกษา',
        academic_information: 'ข้อมูลการศึกษา',
        academic_information_subtitle: 'ข้อมูลจากฐานทะเบียนนักศึกษาปัจจุบัน',
        no_academic_information: 'ไม่พบข้อมูลการศึกษา',
        faculty: 'คณะ',
        department: 'ภาควิชา',
        curriculum: 'หลักสูตร',
        branch: 'สาขาวิชา',
        level: 'ระดับการศึกษา',
        study_plan: 'แผนการศึกษา',
        admission_term: 'ภาคเรียนที่รับเข้าศึกษา',
        student_type: 'ประเภทนักศึกษา',
        thai_student: 'นักศึกษาไทย',
        international_student: 'นักศึกษาต่างชาติ',
        admission_type: 'ประเภทการรับเข้า',
        academic_advisor: 'อาจารย์ที่ปรึกษา (วิชาการ)',
        thesis_advisor: 'อาจารย์ที่ปรึกษา (วิทยานิพนธ์/การค้นคว้าอิสระ)',
        student_status: 'สถานภาพนักศึกษา',
        currently_studying: 'กำลังศึกษา',
        graduated: 'สำเร็จการศึกษา',
        council_approved: 'สภาอนุมัติ',
        recommendation: 'คำแนะนำ',
        check_information: 'ตรวจสอบข้อมูลให้ถูกต้อง',
        check_information_detail: 'หากพบข้อมูลไม่ถูกต้อง กรุณาติดต่อส่วนงานทะเบียนของคณะ',
        check_schedule: 'ตรวจสอบกำหนดการสม่ำเสมอ',
        check_schedule_detail: 'ควรตรวจสอบตารางเรียน ตารางสอบ และกำหนดชำระเงินก่อนดำเนินการ',
        load_error: 'ไม่สามารถโหลดข้อมูลนักศึกษาได้ กรุณาลองอีกครั้ง',
        surrogate_title: 'สวมสิทธิ์แทนนักศึกษา',
        surrogate_subtitle: 'ระบุรหัสนักศึกษาที่ต้องการดำเนินการแทน',
        surrogate_login: 'เข้าสู่ระบบแทนนักศึกษา',
        student_id: 'รหัสนักศึกษา',
        student_id_required: 'กรุณาระบุรหัสนักศึกษา',
        student_id_length: 'รหัสนักศึกษาต้องเป็นตัวเลข 8 หลัก',
    },
    app_bar: {
        title: 'ระบบลงทะเบียนเรียน',
        homepage: 'หน้าหลัก',
        login: 'เข้าสู่ระบบ',
        logout: 'ออกจากระบบ',
        university_name: "สถาบันเทคโนโลยีพระจอมเกล้าเจ้าคุณทหารลาดกระบัง",
    },
    drawer: {
        main_menu: 'เมนูหลัก',
        graduate_officer_menu: 'เมนูเจ้าหน้าที่บัณฑิต',
        user_account: 'บัญชีผู้ใช้งาน',
        surrogate_student: 'สวมสิทธิ์แทนนักศึกษา',
        manual: 'คู่มือการลงทะเบียน',
        undergraduate: 'ระดับปริญญาตรี',
        postgraduate: 'ระดับบัณฑิตศึกษา',
        officer: 'เจ้าหน้าที่',
        teach_table: 'ตารางเรียน-สอบ',
        registration_system: 'ระบบลงทะเบียนเรียน',
        pre_registration: 'ลงทะเบียนล่วงหน้า',
        registration: 'ลงทะเบียนปกติ / เพิ่ม-เปลี่ยน-ถอน',
        student_timetable: 'ตารางเรียนส่วนบุคคล',
        student_exam_timetable: 'ตารางสอบส่วนบุคคล',
        registration_future_innovation: 'ลงทะเบียน 4+1',
        maintain_and_leave: 'รักษาสภาพ / ลาพักการศึกษา',
        registration_for_officer: 'การลงทะเบียน',
        queue_list: 'รายการคิวรอลงทะเบียน',
        pay_tuition_fee: 'ชำระเงินค่าธรรมเนียมการศึกษา',
        for_officer: 'สำหรับเจ้าหน้าที่',
        payment: 'การชำระเงิน',
        student_debt_report: 'รายชื่อนักศึกษาค้างชำระ',
        academic_data_edit: 'แก้ไขข้อมูลการเรียน',
        config: 'การตั้งค่า',
    },
    login: {
        google_authen_title: 'ยืนยันตัวตนด้วยบริการของ Google',
        google_authen_text: 'โดยใช้ Email Account ของสถาบันฯ',
        university_authen_title: 'ยืนยันตัวตนด้วยบริการของสถาบันฯ',
        university_authen_text: 'โดยใช้ Account ของสถาบันฯ',
    },
    footer: {
        registrar: 'สำนักทะเบียนและบริการการศึกษา',
        address1: 'เลขที่ 1 ซอยฉลองกรุง 1',
        address2: 'แขวงลาดกระบัง เขตลาดกระบัง',
        address3: 'กรุงเทพ 10520',
        contact_undergraduate: 'ติดต่อ : ระดับปริญญาตรี',
        contact_graduate: 'ติดต่อ : ระดับบัณฑิตศึกษา',
        ext: "ต่อ",
    },
    toasted: {
        save_successfully: 'บันทึกสำเร็จ',
        cannot_save: 'บันทึกไม่สำเร็จ',
        create_successfully: 'เพิ่มสำเร็จ',
        cannot_create: 'เพิ่มไม่สำเร็จ',
        cannot_upload_file: 'อัปโหลดไฟล์ไม่สำเร็จ',
        file_size_limit: 'ขนาดไฟล์เกินขนาดที่กำหนด (4 MB)',
        delete_successfully: 'ลบสำเร็จ',
        cannot_delete: 'ลบไม่สำเร็จ',
        edit_successfully: 'แก้ไขสำเร็จ',
        cannot_edit: 'แก้ไขไม่สำเร็จ',
        mail_sent: 'ส่งอีเมลแล้ว',
        mail_sent_to: 'ส่งอีเมลแล้ว กรุณาตรวจสอบที่',
    },
    config_teach_table: {
        subject_type: 'วิชาบังคับ/วิชาเลือก',
        subject_owner: 'จัดสอนเอง/สอนบริการ',
        subject_rule_type: 'กำหนดเงื่อนไข',
        faculty: 'คณะ',
        department: 'ภาควิชา',
        curriculum: 'หลักสูตร',
        class: 'ชั้นปี',
        course_category: 'ประเภทวิชา',
        course_id: 'รหัสวิชา',
        year: 'ปีการศึกษา',
        semester: 'ภาคการศึกษา',
        addnew: 'เพิ่มกฎ',
        save: 'บันทึก',
        cancel: 'ยกเลิก',
        save_data_successfully: 'บันทึก \'ข้อมูล\' สำเร็จ โปรดตรวจสอบหน้าตารางสอนอีกครั้ง',
        save_unsuccessfully: 'บันทึกไม่สำเร็จ โปรดติดต่อเจ้าหน้าที่สำนักทะเบียนฯ',
        save_time_slot_successfully: 'บันทึก \'ช่วงเวลาเรียน\' สำเร็จ',
        save_rule_slot_successfully: 'บันทึก \'เงื่อนไขการลงทะเบียนเรียน\' สำเร็จ',
        save_teachtable_show_successfully: 'บันทึก \'การแสดงในหน้าตารางสอนชั้นปี\' สำเร็จ',
    },
    teach_table: {
        title: 'ตารางเรียน - สอบ ระดับปริญญาตรี',
        title_x: 'ตารางเรียน - สอบ ระดับบัณฑิตศึกษา',
        search_by_curr_class: 'ค้นหาตามหลักสูตร / ชั้นปี',
        search_by_curriculum: 'ค้นหาตามหลักสูตร',
        search_by_major: 'ค้นหาตามสาขาวิชา',
        search_by_course_id: 'ค้นหาตามรหัสวิชา',
        search_by_course_name: 'ค้นหาตามชื่อวิชา',
        search_by_course_category: 'ค้นหาตามหมวดวิชา',
        graduate_search_subtitle: 'ค้นหาข้อมูลจากตารางเรียนและตารางสอบระดับบัณฑิตศึกษา',
        admission_type: 'ประเภท',
        admission_semester: 'ภาคเรียนเข้าการศึกษา',
        branch: 'แขนง / สาขา',
        major: 'สาขาวิชา',
        graduate_branch: 'แขนงวิชา',
        selector_load_error: 'ไม่สามารถโหลดข้อมูลตัวเลือกได้ กรุณาลองใหม่อีกครั้ง',
        select_all_faculty: 'เลือกทุกคณะ',
        select_all_department: 'เลือกทุกภาควิชา',
        select_all_curriculum: 'เลือกทุกหลักสูตร',
        select_all_major: 'เลือกทุกสาขาวิชา',
        select_all_class: 'เลือกทุกชั้นปี',
        select_all_branch: 'เลือกทุกแขนง / สาขา',
        select_all_admission_type: 'เลือกทุกประเภทการรับเข้า',
        select_all_admission_semester: 'เลือกทุกภาคเรียนที่เข้า',
        search: 'ค้นหา',
        add_course_to_curr_class: 'เพิ่มวิชาเรียนไปยังตารางสอนหลักสูตร / ชั้นปี',
        searching: "กำลังค้นหา...",
        empty_data: "ไม่มีรายการ",
        empty_teach_table: "ไม่พบตารางเรียน",
        error: "มีบางอย่างผิดพลาด",
        exam_text: {
            contact_instructor: "ติดต่ออาจารย์ผู้สอน",
            contact_faculty: "ติดต่อคณะ",
            no_examination: "ไม่มีการสอบ",
        },
        course_id: "รหัสวิชา",
        course_name: "ชื่อวิชา",
        credit: "หน่วยกิต",
        credit2: "( ทฤษฎี - ปฏิบัติ - ค้นคว้า )",
        section: "กลุ่ม",
        sec_pair: "กลุ่มจับคู่",
        teaching_date: "วัน-เวลาเรียน",
        room: "ห้องเรียน",
        building: "ตึก",
        lecturer: "อาจารย์ผู้สอน",
        exam_date: "วัน-เวลาสอบ",
        condition: "เงื่อนไข",
        seecondition: "ดูทั้งหมด",
        and: "และ",
        note: "หมายเหตุ",
        limit: "รับ",
        pre_registered: "ลง",
        pre_registered2: "ล่วงหน้า",
        registered: "ลง",
        download: "ดาวน์โหลด",
        download_all: "ดาวน์โหลดทั้งหมด",
        queue: "คิว",
        not_accept_other_students: "(ไม่รับนักศึกษาอื่น)",
    },
    room_timetable: {
        title: 'ตารางการใช้ห้องเรียน',
        subtitle: 'ค้นหาการใช้ห้องเรียนของรายวิชาปริญญาตรีและบัณฑิตศึกษา',
        building: 'อาคาร', room: 'ห้องเรียน', day: 'วัน', level: 'ระดับการศึกษา',
        undergraduate: 'ปริญญาตรี', graduate: 'บัณฑิตศึกษา',
        invalid_link: 'กรุณาเปิดจากชื่อห้องเรียนในหน้าตารางเรียน - สอบ',
        empty: 'ไม่พบรายวิชาที่ใช้ห้องนี้ในภาคการศึกษาที่เลือก',
        capacity: 'ความจุ {count} ที่นั่ง', detail_hint: 'คลิกวิชาเพื่อดูรายละเอียดและวันเวลาที่เรียน',
        no_time: 'ยังไม่ระบุเวลาเรียน', actual_dates: 'วันเวลาที่เรียน',
        course_details: 'รายละเอียดรายวิชา', retry: 'ลองอีกครั้ง', export_error: 'ดาวน์โหลดไม่สำเร็จ กรุณาลองอีกครั้ง',
    },
    student_timetable: {
        title: 'ตารางเรียนส่วนบุคคล',
        subtitle: 'แสดงตารางเรียนจากรายวิชาที่ลงทะเบียนแล้ว',
        year_semester: 'ภาคการศึกษา',
        student_id: 'รหัสนักศึกษา',
        updated_at: 'ข้อมูล ณ',
        no_registered_subject: 'ไม่พบรายวิชาที่ลงทะเบียนในภาคการศึกษานี้',
        registration_result: 'ผลการลงทะเบียน',
        print: 'พิมพ์',
        sunday: 'อาทิตย์',
        monday: 'จันทร์',
        tuesday: 'อังคาร',
        wednesday: 'พุธ',
        thursday: 'พฤหัสบดี',
        friday: 'ศุกร์',
        saturday: 'เสาร์',
    },
    queue_list: {
        title: 'รายการคิวรอลงทะเบียน',
        subtitle: 'แสดงรายการคิวรอลงทะเบียนแยกตามรายวิชาและกลุ่ม',
        year: 'ปีการศึกษา',
        semester: 'ภาคการศึกษา',
        subject_id: 'รหัสวิชา',
        section: 'กลุ่ม',
        search: 'ค้นหา',
        clear: 'ล้างตัวเลือก',
        error: 'ไม่สามารถดึงรายการคิวรอลงทะเบียนได้',
        subject_name: 'ชื่อวิชา',
        capacity: 'จำนวนรับ',
        unlimited: 'ไม่จำกัด',
        instructors: 'รายชื่อผู้สอน',
        no_subjects: 'ไม่พบรายวิชาที่เปิดสอนในปีและภาคการศึกษานี้',
        student_id: 'รหัสนักศึกษา',
        status: 'สถานะ',
        waiting: 'รอคิว',
        granted: 'ได้รับสิทธิ์',
        expire_date: 'หมดอายุเมื่อ',
        created_date: 'เข้าคิวเมื่อ',
        no_queue: 'ไม่พบนักศึกษาที่รอคิวในรายวิชาและกลุ่มนี้',
    },
    student_exam_timetable: {
        title: 'ตารางสอบส่วนบุคคล',
        subtitle: 'แสดงตารางสอบจากรายวิชาที่ลงทะเบียนแล้ว',
        year_semester: 'ภาคการศึกษา',
        student_id: 'รหัสนักศึกษา',
        updated_at: 'ข้อมูล ณ',
        no_exam: 'ไม่พบตารางสอบในภาคการศึกษานี้',
        exam_type: 'ประเภทการสอบ',
        self_arranged: 'จัดสอบเอง',
        exam_location: 'อาคาร - ห้อง - ที่นั่งสอบ',
        seat_map: 'แผนผังห้องสอบ',
        room_front: 'หน้าห้องสอบ',
        assigned_seat: 'ที่นั่งสอบของคุณ',
        other_seat: 'ที่นั่งอื่น',
        no_seat: 'ยังไม่มีการจัดห้องสอบ',
        back_to_timetable: 'กลับไปหน้าตารางสอบ',
        building: 'อาคาร',
        room: 'ห้อง',
        seat: 'ที่นั่งสอบ',
        scroll_left_hint: 'เลื่อนไปทางซ้ายเพื่อดูแผนผังเพิ่มเติม',
    },
    lect_or_prac_chip: {
        practice: 'ปฏิบัติ',
        lecture: 'ทฤษฎี',
    },
    pre_registration: {
        registration_system: 'ลงทะเบียนล่วงหน้า ระดับปริญญาตรี',
    },
    registration: {
        registration_system: 'ลงทะเบียนเรียน ระดับปริญญาตรี',
        registration_system_x: 'ลงทะเบียนเรียน ระดับบัณฑิตศึกษา',
        "registration_system_4+1": 'ลงทะเบียนเรียน โครงการแววนวัตกร',
        registration_system_for_officer: 'ลงทะเบียนเรียน สำหรับเจ้าหน้าที่',
        subject_type_description: '* Credit(Cr) = รายวิชาที่นับหน่วยกิต / Audit(Ad) = รายวิชาร่วมเรียน / Transfer(Tr) = รายวิชาเทียบโอน / Non Credit(Nc) = รายวิชาไม่นับหน่วยกิต',
        view_transaction: 'ดูประวัติการลงทะเบียน / เพิ่ม / เปลี่ยน / ถอน',
        add_subject: 'เพิ่มรายวิชา',
        change_subject: 'เปลี่ยนรายวิชา',
        withdraw_subject: 'ถอนรายวิชา',
        select_subject_to_change_out: 'เลือกวิชาที่ต้องเปลี่ยนออก',
        select_subject_to_withdraw: 'เลือกวิชาที่ต้องการถอน',
        select_subject_to_change_in: 'เลือกวิชาที่ต้องเปลี่ยนเข้า',
        select_subject_to_add: 'เลือกวิชาที่ต้องการเพิ่ม',
        add: 'เพิ่ม',
        change: 'เปลี่ยน',
        withdraw: 'ถอน',
        continuous: 'ดำเนินการต่อ',
        cancel: 'ยกเลิก',
        confirm_title: 'ยืนยันการทำรายการ',
        confirm_text: 'โปรดตรวจสอบข้อมูลให้ถูกต้อง เมื่อดำเนินการแล้วจะไม่สามารถยกเลิกได้',
        confirm: 'ยืนยัน',
        back: 'ย้อนกลับ',
        regis_type_m_status: 'สถานะ : รักษาสถานภาพนักศึกษา',
        regis_type_d_status: 'สถานะ : ลาพักการศึกษา',
    },
    pre_regis_add_subject: {
        add_description: 'กรอกรหัสวิชาที่กล่องด้านล่าง จากนั้นกดปุ่ม "เพิ่ม" เพื่อเพิ่มรายวิชา',
        delete: 'ลบ',
        list_subject_need_to_regis: 'รายการวิชาที่ต้องการลงทะเบียน',
        early: 'ล่วงหน้า',
        subject_name: 'ชื่อวิชา',
        credit: 'หน่วยกิต',
        section: 'กลุ่ม',
        type: 'ประเภทหน่วยกิต',
        class_exam_timetable: 'เวลาเรียน - เวลาสอบ ',
        limit: 'รับ',
        number_of_people_registered: 'ลง',
        practice: '(ปฏิบัติ)',
        add: 'เพิ่ม',
        credits_that_student_can_take: 'หน่วยกิตที่ลงได้',
        please_contact_officer: 'โปรดติดต่อเจ้าหน้าที่สำนักทะเบียนฯ',
        all_registered_credits: 'หน่วยกิตรวมวิชาที่เลือกทั้งหมด',
        continuous: 'ดำเนินการต่อ',
        grade_not_release: 'มีวิชาที่เกรดยังไม่ออก',
        subject_id: 'รหัสวิชา',
        prerequisite_has_no_grade: 'มีข้อกำหนดวิชาที่ต้องผ่านก่อน ซึ่งรายวิชาเหล่านี้ยังไม่มีผลการเรียน',
        confirm_on_registration_date: 'เมื่อถึงวันลงทะเบียนจริง หากเกรดที่ออกมาไม่เข้าเงื่อนไขการลงทะเบียน ระบบจะยกเลิกการลงทะเบียนรายวิชา',
        roger: 'รับทราบ',
        one_time_registration: 'การลงทะเบียนล่วงหน้าสามารถลงได้ครั้งเดียว',
        one_time_regis_cannot_edit: 'นักศึกษาจะลงทะเบียนล่วงหน้าได้เพียงครั้งเดียว และหลังจากลงทะเบียนสำเร็จแล้วจะไม่สามารถแก้ไขการลงทะเบียนล่วงหน้าได้',
        back: 'กลับไปดูข้อมูล',
        confirm: 'ยืนยัน',
        result: 'ผลการลง',
        waiting: 'รอผล',
        close: 'ปิด',
        error_in_taking_this_course: 'มีข้อผิดพลาดสำหรับการลงวิชา: ',
        exam_collide: 'มีวันเวลาสอบชนกับวิชาที่เลือกไว้แล้ว',
        time_slot_collide: 'มีวันเวลาเรียนชนกับวิชาที่เลือกไว้แล้ว',
        prac_exam_collide: 'ในกลุ่ม "ปฏิบัติ" มีวันเวลาสอบชนกับวิชาที่เลือกไว้แล้ว',
        prac_time_slot_collide: 'ในกลุ่ม "ปฏิบัติ" มีวันเวลาเรียนชนกับวิชาที่เลือกไว้แล้ว',
        pre_registration_complete: 'ลงทะเบียนล่วงหน้าสำเร็จ',
        already_in_list: "มีวิชานี้อยู่ในรายการที่จะลงอยู่แล้ว",
        case_subject_type_co_operative: "วิชาสหกิจ และวิชาฝึกงาน ไม่สามารถลงร่วมกับวิชาอื่น ๆ ได้ในเทอมเดียวกัน และไม่สามารถถอนออกได้",
        case_future_innovation_over_6_credit: "นักศึกษาโครงการแววนวัตกร สามารถลงวิชาที่คิดหน่วยกิตได้ไม่เกิน 6 หน่วยกิต ต่อภาคการศึกษา",
        defined_by_instructor: "จัดสอบเอง",
    },
    regis_add_subject: {
        number_of_people_registered: 'ลง + คิว',
        number_of_people_registered_x: 'ลง',
        one_time_registration: 'การลงทะเบียนปกติสามารถลงได้ครั้งเดียว',
        one_time_regis_cannot_edit: 'นักศึกษาจะลงทะเบียนปกติได้เพียงครั้งเดียวและหลังจากลงทะเบียนปกติสำเร็จแล้วจะไม่สามารถแก้ไขผลการลงทะเบียนได้ หากต้องการ เพิ่ม-เปลี่ยน-ถอน รายวิชาสามารถทำได้ในช่วงเวลาเพิ่มเปลี่ยนถอน ตามเวลาที่กำหนดในปฏิทินการศึกษา',
        some_courses_you_have_right_but_not_register: 'มีบางรายวิชาที่คุณได้สิทธิ์แต่ไม่ได้ใช้ลงทะเบียน',
        if_registration_process_has_been_completed_will_be_deemed_to_have_waived_these_rights_immediately: 'หากดำเนินการลงทะเบียนจนเสร็จสิ้นแล้ว จะถือว่าสละสิทธิ์วิชาเหล่านี้ทันที',
    },
    pre_regis_pageinfo: {
        registration_check_result: 'ลงทะเบียน / ตรวจสอบผล',
        not_yet_logged_in_or_not_at_given_time: 'นักศึกษายังไม่ได้ Login หรือไม่ได้ใช้งานในเวลาที่กำหนด',
        back_to_log_in_page: 'กรุณากลับไปหน้า Login',
        go_to_log_in_page: 'เข้าสู่หน้า Login',
        not_during_pre_registration_period: 'ไม่อยู่ในช่วงเวลาลงทะเบียนล่วงหน้า',
        pre_registration_period: 'ช่วงเวลาลงทะเบียนล่วงหน้า',
        year: 'ปีการศึกษา',
        is: 'คือ',
        not_in_study_status_so_cant_pre_registrtion: "นักศึกษาไม่ได้อยู่ในสถานะ 'เรียน' จึงไม่สามารถลงทะเบียนล่วงหน้าได้",
        student_1st_year_semester_1_cant_pre_register: 'นักศึกษาปี 1 ในเทอม 1 จะไม่สามารถลงทะเบียนล่วงหน้าได้',
        because_registered_according_to_plan_for_student_1st_year_semester_1: 'เนื่องจากระบบได้ลงทะเบียนตามแผนการเรียนให้นักศึกษาปี 1 ในเทอม 1 เรียบร้อยแล้ว หากต้องการลงทะเบียนเพิ่มเติมสามารถลงได้ในช่วง เพิ่ม-เปลี่ยนรายวิชา ตามวันเวลาในปฏิทินการศึกษา',
        students_cant_pre_register_because: 'นักศึกษาไม่สามารถลงทะเบียนล่วงหน้าได้ เนื่องจาก',
        have_any_inquiries_please_dont_hesitate_to_contact: 'หากมีข้อสงสัยกรุณาติดต่อเจ้าหน้าที่ฝ่ายทะเบียน ที่',
        students_dont_pre_register_during_the_specified_period: 'นักศึกษาไม่ได้ลงทะเบียนล่วงหน้าในช่วงเวลาที่กำหนด',
    },
    regis_pageinfo: {
        not_during_registration_period: 'ไม่อยู่ในช่วงเวลาลงทะเบียนปกติ',
        registration_period: 'ช่วงเวลาลงทะเบียนปกติ',
        not_in_study_status_so_cant_registrtion: "นักศึกษาไม่ได้อยู่ในสถานะ 'เรียน' จึงไม่สามารถลงทะเบียนปกติได้",
        student_1st_year_semester_1_cant_register: 'นักศึกษาปี 1 ในเทอม 1 จะไม่สามารถลงทะเบียนปกติได้',
        students_cant_register_because: 'นักศึกษาไม่สามารถลงทะเบียนปกติได้ เนื่องจาก',
        students_dont_register_during_the_specified_period: 'นักศึกษาไม่ได้ลงทะเบียนปกติในช่วงเวลาที่กำหนด',
        see_calendar: 'ดูปฏิทินการศึกษา',
    },
    pre_regis_complete: {
        list_of_registered_subjects: 'รายการวิชาที่ลงทะเบียน',
        early: '(ล่วงหน้า)',
        can_register: 'ได้รับสิทธิ์',
        can_not_register: 'ไม่ได้รับสิทธิ์ (อยู่ในแถวคอย)',
        can_not_register_violate_condition: 'ไม่ได้รับสิทธิ์เนื่องจากผิดเงื่อนไข',
    },
    information: {
        undergraduate: 'ระดับปริญญาตรี',
        postgraduate: 'ระดับบัณฑิตศึกษา',
        title: 'คำแนะนำการลงทะเบียน',
        no_1: '1. นักศึกษาจะต้องลงทะเบียนด้วยตัวเองเท่านั้น',
        no_2: '2. ควรตรวจสอบรายวิชาที่ลงทะเบียน',
        no_2cut1: 'ให้เป็นไปตามเล่มหลักสูตร',
        no_3: '3. สิ้นสุดการลงทะเบียนล่วงหน้า ระบบจะทำการสุ่มสิทธิ์ โดย',
        no_3cut1: 'ลำดับในการลงทะเบียนล่วงหน้า ไม่มีผลต่อการได้สิทธิ์',
        no_4: '4. เมื่อลงทะเบียนล่วงหน้า เรียบร้อยแล้ว ให้เข้ามาตรวจสอบผลการลงทะเบียนล่วงหน้า ในระบบ ในวันประกาศผลลงทะเบียนล่วงหน้า',
        student: 'นักศึกษา',
        no_5cut1: 'ต้องมาลงทะเบียนปกติ ทุกคน',
        no_6: 'ช่วงลงทะเบียนปกติ',
        no_6_1: '6.1 นักศึกษา ที่ได้สิทธิ์รายวิชา ในช่วงลงทะเบียนล่วงหน้า ',
        no_6_1cut1: 'ต้องมาลงทะเบียนปกติ',
        no_6_1cut2: 'เพื่อยืนยันการลงทะเบียนล่วงหน้า ที่ได้รับสิทธิ์',
        no_6_2: '6.2 นักศึกษา ที่ไม่ได้ สิทธิ์รายวิชา ในช่วงลงทะเบียนล่วงหน้า ',
        no_6_2cut1: 'ต้องมาลงทะเบียนปกติ',
        no_6_2cut2: 'เพื่อยืนยัน การลงทะเบียนในวิชาที่ต้องการเรียน และวิชาที่ไม่ได้สิทธิ์ ลงทะเบียนล่วงหน้า',
        no_6_3: '6.3 นักศึกษา ที่ไม่ลงทะเบียน ในช่วงลงทะเบียนล่วงหน้า',
        no_6_3cut1: 'ต้องมาลงทะเบียนปกติ',
        no_6_3cut2: 'เพื่อทำการลงทะเบียนรายวิชาเรียนตามเงื่อนไขของหลักสูตรของตนเอง',
        no_6_4: '6.4 นักศึกษา สามารถลงทะเบียนปกติ',
        no_6_4cut1: 'ได้เพียงครั้งเดียวเท่านั้น',
        no_6_4cut2: 'หากต้องการเพิ่มรายวิชาเรียนสามารถเพิ่มรายวิชาในช่วงเวลา เพิ่ม/เปลี่ยน/ถอน รายวิชา',
        no_7: 'ช่วง เพิ่ม/เปลี่ยน/ถอน',
        no_7_1: 'นักศึกษา ผู้ไม่ได้ สิทธิ์รายวิชา ในช่วงลงทะเบียนล่วงหน้า และยืนยันสิทธิ์ ในช่วงลงทะเบียนปกติ จะมีรายชื่ออยู่ในแถวคอย เมื่อมีที่ว่างในรายวิชาที่ ไม่ได้สิทธิ์ ลงทะเบียนล่วงหน้าไว้ และถึงลำดับของนักศึกษาในแถวคอย ระบบจะส่งอีเมลแจ้งไปทาง อีเมลสถาบันฯ (xxxxxxxx@kmitl.ac.th) โดยนักศึกษาที่ได้รับอีเมลแจ้ง จะต้องมาลงทะเบียน ในช่วง เพิ่ม/เปลี่ยน/ถอน เพื่อยืนยันสิทธิ์ ภายในระยะเวลาตามที่แจ้งในอีเมล',
        no_7_2: 'นักศึกษาที่ลงทะเบียนปกติ และต้องการ เพิ่ม/เปลี่ยน/ถอน ให้เข้าระบบมาดำเนินการได้ตามช่วงเวลาที่กำหนดในปฎิทินการศึกษา',
        accept: 'กลับสู่หน้าหลัก',
        grad_no_0: '* นักศึกษาระดับบัณฑิตศึกษาไม่มีการลงทะเบียนล่วงหน้า',
    },
    pre_regis_flow_chart: {
        next: 'เข้าสู่ขั้นตอนการลงทะเบียน',
    },
    pre_regis_stepper: {
        start: 'เริ่มต้น',
        select_subject: 'เลือกรายวิชา',
        complete: 'เสร็จสิ้น',
        curriculum: 'หลักสูตรหน้าเว็บ KRESO',
        curriculumOAQ: 'หลักสูตรหน้าเว็บ OAQ',
        timetable: 'ตารางเรียน-สอบ',
        academic_calendar: 'ปฏิทินการศึกษา',
    },
    pre_regis_panel: {
        student_id: 'รหัสนักศึกษา',
        name_surname: 'ชื่อ-นามสกุล',
        semester: 'ภาคการศึกษาที่',
    },
    queue_table_panel: {
        subjects_eligible_for_registration: 'วิชาที่ได้สิทธิ์การลงทะเบียน',
        details: '(กรุณาเลือกวิชาที่ต้องการใช้สิทธิ์ กรอกรหัสวิชาไปยัง "รายวิชาที่ต้องการลงทะเบียน" ด้านบน)',
        entitled_to: 'มีสิทธิ์ถึง',
        waiver: 'สละสิทธิ์',
        no_item: 'ไม่มีรายการ',
        retrospective_button: 'ดูรายการแถวคอยย้อนหลัง',
        retrospective_list: 'รายการแถวคอยย้อนหลัง',
        status: 'สถานะ',
        time: 'เวลา',
        this_right_has_been_used_for_registration: 'ใช้สิทธิ์นี้ในการลงทะเบียนแล้ว',
        this_right_is_not_used_for_registration: 'ไม่ได้ใช้สิทธิ์นี้ในการลงทะเบียน',
        this_right_is_not_used_in_the_specified_period: 'ไม่ได้ใช้สิทธิ์ในระยะเวลาที่กำหนด',
        student_manually_removed_from_the_waiting_list: 'นักศึกษาลบออกจากแถวคอยด้วยตนเอง',
        confirm_the_deletion_of_the_course_from_the_queue: 'ยืนยันการลบวิชาออกจากแถวคอย',
    },
    queue_table: {
        subjects_in_the_queue: 'วิชาที่อยู่ในแถวคอย',
        description: '(การจำกัดจำนวนคิวที่สามารถต่อคิวรอได้มากที่สุด 5 คิว จะเริ่มจำกัดในช่วงระยะเวลา เพิ่มเปลี่ยนรายวิชา)',
        cancel_queue: 'ยกเลิกคิว',
        no_itme: 'ไม่มีรายการ',
    },
    pattern_table: {
        course_registration_information: 'ข้อมูลการลงทะเบียนตามหลักสูตร',
        students_should_check_course_submission_according_to_the_course_plan: '(นักศึกษาควรตรวจสอบการลงรายวิชาให้เป็นไปตามแผนของหลักสูตร)',
    },
    config_academic: {
        title: 'ตั้งค่าการลงทะเบียน',
        config_academic: 'ตั้งค่าวันลงทะเบียน',
        addnew: 'เพิ่มใหม่',
        sub_level_id: '4+1',
        year: 'ปีการศึกษา',
        semester: 'ภาคการศึกษา',
        start_datetime_system: 'วันที่เริ่มใช้ปีการศึกษา (เช่น วันที่เปิดลงทะเบียนล่วงหน้า)',
        start_datetime_academic: 'วันที่เปิดภาคการศึกษา',
        end_datetime_academic: 'วันที่ปิดภาคการศึกษา',
        start_datetime_config_teach_table: 'วันที่เปิด [ตั้งค่าตารางสอน]',
        end_datetime_config_teach_table: 'วันที่ปิด [ตั้งค่าตารางสอน]',
        start_datetime_midterm: 'วันที่เปิด [สอบกลางภาค]',
        end_datetime_midterm: 'วันที่ปิด [สอบกลางภาค]',
        start_datetime_final: 'วันที่เปิด [สอบปลายภาค]',
        end_datetime_final: 'วันที่ปิด [สอบปลายภาค]',
        start_datetime_pre_regis: 'วันที่เปิด [ลงทะเบียนล่วงหน้า]',
        end_datetime_pre_regis: 'วันที่ปิด [ลงทะเบียนล่วงหน้า]',
        start_datetime_regis: 'วันที่เปิด [ลงทะเบียนปกติ]',
        end_datetime_regis: 'วันที่ปิด [ลงทะเบียนปกติ]',
        start_datetime_add_change: 'วันที่เปิด [เพิ่ม-เปลี่ยน]',
        end_datetime_add_change: 'วันที่ปิด [เพิ่ม-เปลี่ยน]',
        start_datetime_withdraw: 'วันที่เปิด [ถอน]',
        end_datetime_withdraw: 'วันที่ปิด [ถอน]',
        edit: 'แก้ไข',
        delete: 'ลบ',
        confirm: 'ตกลง',
        cancel: 'ยกเลิก',
        save: 'บันทึก',
        confirm_delete: 'ยืนยันการลบ',
    },
    config_payment: {
        config_payment: 'ตั้งค่าการชำระเงิน',
        start_datetime_no_charge: 'วันแรก [ชำระเงินไม่คิดค่าปรับ]',
        end_datetime_no_charge: 'วันสุดท้าย [ชำระเงินไม่คิดค่าปรับ]',
        start_datetime_regist_charge: 'วันแรก [ปรับ ลทบ. ล่าช้า]',
        end_datetime_regist_charge: 'วันสุดท้าย [ปรับ ลทบ. ล่าช้า]',
        regist_charge: 'ค่าปรับ [ลทบ.ล่าช้า]',
        start_datetime_pay_late_charge: 'วันแรก [ปรับชำระเงินล่าช้า]',
        end_datetime_pay_late_charge: 'วันสุดท้าย [ปรับชำระเงินล่าช้า]',
        pay_late_charge_per_day: 'ค่าปรับ/วัน [ชำระเงินล่าช้า]',
        last_datetime_pay_date: 'วันสุดท้าย [การชำระเงิน]',
        amount: 'จำนวน',
    },
    config_medicine: {
        title: 'ตั้งค่าคณะแพทยศาสตร์',
        subtitle: 'รายชื่อนักศึกษา ไปฝึก/เรียนที่โรงพยาบาลสิรินธร เพื่อการปันส่วนค่าธรรมเนียมการศึกษา',
        student_id: 'รหัสนักศึกษา',
        name: 'ชื่อ-สกุล',
        date: 'วันที่บันทึก',
    },
    regis_transaction: {
        title: "ประวัติการลงทะเบียน เพิ่ม / เปลี่ยน / ถอน",
        order: "ลำดับ",
        type: "ประเภทการลงทะเบียน",
        subject_id: "รหัสวิชา",
        subject_name: "ชื่อวิชา",
        section: "กลุ่ม",
        timestamp: "เวลา",
        tran_type_r: "ลงทะเบียนปกติ",
        tran_type_a: "เพิ่ม",
        tran_type_c: "เปลี่ยน",
        tran_type_d: "ถอน",
        changed_to: "เปลี่ยนเป็น",
    },
    payment: {
        title: 'ระบบชำระเงิน',
        officer_title: 'ระบบชำระเงิน สำหรับเจ้าหน้าที่',
        search: 'ค้นหา',
        load_error: 'ไม่สามารถโหลดข้อมูลการชำระเงินได้ กรุณาลองอีกครั้ง',
        student_mode_unavailable: 'ไม่สามารถตรวจสอบเงื่อนไขการชำระเงินในสิทธิ์นักศึกษาได้ กรุณาติดต่อผู้ดูแลระบบ',
        system_undergraduate: 'ระดับปริญญาตรี',
        system_graduate: 'ระดับบัณฑิตศึกษา',
        "system_4+1": 'โครงการแววนวัตกร',
        year: 'ปีการศึกษา',
        transaction: 'รายการ',
        tuition_fee: 'ค่าธรรมเนียมการศึกษา',
        tuition_fee_header_1: 'ค่าธรรมเนียม',
        tuition_fee_header_2: 'การศึกษา',
        discount: 'ส่วนลดจากสถาบันฯ',
        discount_header_1: 'ส่วนลดจาก',
        discount_header_2: 'สถาบันฯ',
        other_fee: 'ค่าธรรมเนียมอื่น ๆ',
        other_fee_header_1: 'ค่าธรรมเนียม',
        other_fee_header_2: 'อื่น ๆ',
        subsidy_fee: 'ค่าอุดหนุนการศึกษา',
        thesis_fee: 'ค่าสอบวิทยานิพนธ์',
        compre_fee: 'ค่าสอบประมวลความรู้',
        qe_fee: 'ค่าสอบวัดคุณสมบัติ',
        late_chart: 'ค่าปรับลงทะเบียนล่าช้า',
        late_chart_header_1: 'ค่าปรับลงทะเบียน',
        late_chart_header_2: 'ล่าช้า',
        pay_chart: 'ค่าปรับชำระเงินล่าช้า',
        pay_chart_header_1: 'ค่าปรับชำระเงิน',
        pay_chart_header_2: 'ล่าช้า',
        first_year_first_semester_no_pay_charge: 'ปี1 เทอม1 ไม่คิดค่าปรับฯ',
        paid: 'ชำระแล้ว',
        remain: 'ยอดค้างชำระ',
        print: 'การชำระเงิน',
        complete: 'ชำระเงินแล้ว',
        note_late_chart: '*** นักศึกษาที่ลงทะเบียนล่าช้าจะต้องชำระเงินค่าปรับ 300 บาท ***',
        note_pay_chart_1: '*** นักศึกษาที่ชำระเงินล่าช้าจะต้องชำระเงินค่าปรับ วันละ',
        note_pay_chart_2: 'บาท ***',
        notification: 'แจ้งเตือน',
        notification_1: 'หากไม่ชำระเงินภายในวันที่กำหนดตามใบแจ้งการชำระเงินค่าธรรมเนียมการศึกษา จะไม่สามารถทำรายการชำระเงินได้ ขอให้นักศึกษาตรวจสอบรายละเอียดของจำนวนเงินและกำหนดวันสุดท้ายของการชำระเงิน จากใบแจ้งการชำระเงินค่าธรรมเนียมการศึกษาให้เป็นปัจจุบัน',
        notification_2: 'หากวันที่ต้องการชำระเงินตรงกับกำหนดวันสุดท้ายของการชำระ ขอให้ทำการชำระเงินก่อนเวลา 23:00 น.',
        notification_3: 'หากอยู่ในช่วงวันที่มีการคิดค่าปรับชำระเงินล่าช้ารายวัน การชำระเงินจะสามารถดำเนินการได้ตั้งแต่เวลา 01:00 - 22:59 น. (ไม่สามารถชำระได้ในช่วง 23:00 - 00:59 น.)',
        credit_card: 'บัตรเครดิต',
        billing: '= สามารถขอรับใบเสร็จได้',
        request_receipt: 'ขอใบเสร็จ',
        edit: 'แก้ไข',
        delete: 'ลบ',
        order: 'ลำดับ',
        actions: 'จัดการ',
        save: 'บันทึก',
        cancel: 'ยกเลิก',
        baht: 'บาท',
        edit_tuition_fee: 'แก้ไขค่าธรรมเนียมการศึกษา',
        leave_fee: 'ค่าลาพักการศึกษา',
        edit_leave_fee: 'แก้ไขค่าลาพักการศึกษา',
        maintain_fee: 'ค่ารักษาสถานภาพนักศึกษา',
        edit_maintain_fee: 'แก้ไขค่ารักษาสถานภาพนักศึกษา',
        edit_other_fees: 'แก้ไขค่าธรรมเนียมอื่น ๆ',
        view_other_fees: 'ดูรายละเอียดค่าธรรมเนียมอื่น ๆ',
        other_fee_details: 'รายละเอียดค่าธรรมเนียมอื่น ๆ',
        edit_late_charge: 'แก้ไขค่าปรับลงทะเบียนล่าช้า (300 บาท)',
        exempt_late_charge: 'ยกเว้นค่าปรับ',
        add_late_charge: 'ไม่ยกเว้นค่าปรับ',
        select_late_charge_action: 'เลือกการดำเนินการสำหรับค่าปรับลงทะเบียนล่าช้า',
        edit_pay_charge: 'แก้ไขค่าปรับชำระเงินล่าช้า',
        exempt_pay_charge: 'ยกเว้นค่าปรับ',
        add_pay_charge: 'ไม่ยกเว้นค่าปรับ',
        select_pay_charge_action: 'เลือกการดำเนินการสำหรับค่าปรับชำระเงินล่าช้า',
        penalty_status_exempt: 'ยกเว้นค่าปรับ',
        penalty_status_charge: 'คิดค่าปรับตามเงื่อนไขระบบ',
        penalty_saved_status: 'สถานะปัจจุบัน:',
        academic_period: 'ภาคการศึกษา {semester} / {year}',
        amount_required: 'กรุณาระบุจำนวนเงิน',
        amount_integer: 'จำนวนเงินต้องเป็นจำนวนเต็ม',
        amount_nonnegative_integer: 'จำนวนเงินต้องเป็นจำนวนเต็มตั้งแต่ 0 ขึ้นไป',
        update_success: 'บันทึกค่าธรรมเนียมเรียบร้อยแล้ว',
        update_failed: 'ไม่สามารถบันทึกค่าธรรมเนียมได้',
        edit_recalculate_note: 'หลังบันทึก ระบบจะคำนวณยอดค้างชำระใหม่จากข้อมูลล่าสุด',
        confirm_update_title: 'ยืนยันการแก้ไขข้อมูลการชำระเงิน',
        confirm_update_message: 'กรุณาตรวจสอบข้อมูลให้ถูกต้องก่อนยืนยัน การแก้ไขนี้จะเปลี่ยนยอดที่ใช้คำนวณใบชำระเงินของนักศึกษา',
        confirm_and_save: 'ยืนยันและบันทึก',
        education_level: 'ระดับการศึกษา',
        faculty_college_campus: 'คณะ/วิทยาลัย/วิทยาเขต',
        registration_type: 'ประเภทการลงทะเบียน',
        change_details: 'รายละเอียดการเปลี่ยนแปลง',
        current_value: 'ค่าเดิม',
        new_value: 'ค่าใหม่',
        other_fee_total: 'รวมค่าธรรมเนียมอื่น ๆ',
        current_payment_summary: 'ข้อมูลการชำระเงินก่อนแก้ไข',
        no_changes: 'ไม่มีข้อมูลที่เปลี่ยนแปลง',
        close: 'ปิด',
        view_only: 'ดูข้อมูลเท่านั้น',
        view_payment_details: 'ดูรายละเอียดการจ่ายเงิน',
        payment_details: 'รายละเอียดการจ่ายเงิน',
        no_payment_details: 'ไม่พบรายละเอียดการจ่ายเงินในภาคการศึกษานี้',
        verified_payment_records: 'รายการที่ออกใบเสร็จแล้ว',
        registration_and_payment_records: 'ข้อมูลการลงทะเบียนและรายการชำระเงิน',
        pending_payment_records: 'รายการที่ชำระแล้วและรอตรวจสอบ',
        pending_payment_note: 'รายการนี้ธนาคารยืนยันการชำระแล้ว แต่ยังไม่ได้จับคู่กับใบเสร็จในระบบทะเบียน',
        receipt_number: 'เลขที่ใบเสร็จ',
        receipt_count: 'ใบเสร็จ {count} รายการ',
        payment_date_time: 'วัน-เวลาชำระเงิน',
        transaction_date: 'วันที่ทำรายการ',
        record_date: 'วันที่',
        payment_date: 'วันที่ชำระเงิน',
        payment_date_buddhist: 'วันที่ชำระเงิน (พ.ศ.)',
        payment_date_buddhist_placeholder: 'เลือกวันที่ชำระเงิน',
        select_payment_date: 'เลือกวันที่ชำระเงิน',
        use_selected_date: 'เลือกวันที่นี้',
        invalid_buddhist_date: 'กรุณาระบุวันที่ให้ถูกต้องในรูปแบบ วัน/เดือน/พ.ศ.',
        total_paid: 'ยอดชำระรวม',
        total: 'รวม',
        bank: 'ธนาคาร / ช่องทางชำระเงิน',
        bank_required: 'กรุณาเลือกธนาคารหรือช่องทางชำระเงิน',
        no_billing_codes: 'ไม่พบธนาคารหรือช่องทางชำระเงิน',
        no_billing_codes_for_level: 'ไม่พบธนาคารหรือช่องทางชำระเงินสำหรับระดับการศึกษานี้',
        billing_codes_load_failed: 'ไม่สามารถโหลดรายการธนาคารหรือช่องทางชำระเงินได้',
        reference_number: 'เลขที่อ้างอิง',
        edit_payment_record: 'แก้ไขรายละเอียดการจ่ายเงิน',
        create_payment_record: 'บันทึกรายการชำระเงิน',
        automatic_receipt_number: 'ระบบจะสร้างให้อัตโนมัติ',
        billing_edit_recalculate_note: 'เมื่อบันทึก ระบบจะคำนวณยอดรวมของรายการนี้ใหม่จากค่าธรรมเนียมทั้งหมด',
        new_total: 'ยอดรวมใหม่',
        confirm_billing_update_title: 'ยืนยันการแก้ไขรายละเอียดการจ่ายเงิน',
        confirm_billing_update_message: 'กรุณาตรวจสอบรหัสนักศึกษา ปีการศึกษา เลขที่ใบเสร็จ และค่าที่เปลี่ยนแปลงก่อนยืนยัน',
        billing_update_success: 'บันทึกรายละเอียดการจ่ายเงินเรียบร้อยแล้ว',
        confirm_billing_create_title: 'ยืนยันการบันทึกรายการชำระเงิน',
        confirm_billing_create_message: 'กรุณาตรวจสอบรหัสนักศึกษา ปีการศึกษา วันที่ชำระ ธนาคาร และจำนวนเงินก่อนยืนยัน ระบบจะออกเลขที่ใบเสร็จให้อัตโนมัติ',
        billing_create_success: 'เพิ่มรายการชำระเงินเรียบร้อยแล้ว',
        payment_record_number: 'รายการที่ {number}',
        registration_number: 'เลขที่ลงทะเบียน',
        registration_information: 'ข้อมูลการลงทะเบียน',
        registration_type_s: 'ลงทะเบียนปกติ',
        registration_type_m: 'รักษาสภาพนักศึกษา',
        registration_type_d: 'ลาพักการศึกษา',
        registration_transaction_a: 'เพิ่ม',
        registration_transaction_c: 'เปลี่ยน',
        registration_transaction_d: 'ถอน',
        confirm_billing_delete_title: 'ยืนยันการลบรายการชำระเงิน',
        confirm_billing_delete_message: 'การลบรายการจะทำให้ยอดชำระและสถานะการชำระเงินของนักศึกษาเปลี่ยนแปลง กรุณาตรวจสอบข้อมูลและระบุเหตุผลก่อนยืนยัน',
        delete_payment_record: 'ลบรายการชำระเงิน',
        delete_reason: 'เหตุผลในการลบรายการ',
        delete_reason_hint: 'กรุณาระบุเหตุผลอย่างน้อย 3 ตัวอักษร',
        billing_delete_success: 'ลบรายการชำระเงินเรียบร้อยแล้ว',
        billing_delete_failed: 'ไม่สามารถลบรายการชำระเงินได้',
        invalid_payment_data: 'ไม่สามารถอ่านข้อมูลการชำระเงินได้ กรุณาลองใหม่หรือติดต่อผู้ดูแลระบบ',
        academic_period_label: 'ปีการศึกษา / ภาคการศึกษา',
        billing_field_credit_fee: 'ค่าหน่วยกิต',
        billing_field_package_fee: 'ค่าธรรมเนียมการศึกษา',
        billing_field_student_fee: 'ค่าขึ้นทะเบียนนักศึกษา',
        billing_field_student_card: 'ค่าบัตรประจำตัวนักศึกษา',
        billing_field_health_check: 'ค่าตรวจสุขภาพ',
        billing_field_institute_fee: 'ค่าบำรุงสถาบัน',
        billing_field_library_fee: 'ค่าบำรุงห้องสมุด',
        billing_field_internet_fee: 'ค่าบริการอินเทอร์เน็ต',
        billing_field_health_service: 'ค่าบริการสุขภาพ',
        billing_field_sport_fee: 'ค่าบริการกีฬา',
        billing_field_activity_fee: 'ค่ากิจกรรมนักศึกษา',
        billing_field_accident_insure: 'ค่าประกันอุบัติเหตุ',
        billing_field_leave_fee: 'ค่าลาพักการศึกษา',
        billing_field_maintain_fee: 'ค่ารักษาสถานภาพนักศึกษา',
        billing_field_special_fee1: 'ค่าธรรมเนียมพิเศษ 1',
        billing_field_special_fee2: 'ส่วนลดจากสถาบันฯ',
        billing_field_subsidy_fee: 'ค่าเงินอุดหนุนการศึกษา',
        billing_field_late_charge: 'ค่าปรับลงทะเบียนล่าช้า',
        billing_field_pay_charge: 'ค่าปรับชำระเงินล่าช้า',
        billing_field_else: 'อื่น ๆ',
        billing_field_document_fee: 'ค่าบริการเอกสาร',
        billing_field_property_insure: 'ค่าประกันทรัพย์สิน',
        billing_field_thesis_fee: 'ค่าสอบวิทยานิพนธ์',
        billing_field_comp_fee: 'ค่าสอบประมวลความรู้',
        billing_field_qe_fee: 'ค่าสอบวัดคุณสมบัติ',
        student_notes: 'บันทึกความจำ',
        add_student_note: 'เพิ่มบันทึกความจำ',
        student_note_history: 'ประวัติบันทึกความจำ',
        student_note_date: 'วัน-เวลา',
        student_note_message: 'ข้อความ',
        student_note_author: 'ผู้บันทึก',
        student_note_placeholder: 'ระบุข้อความที่ต้องการบันทึกเกี่ยวกับนักศึกษาคนนี้',
        student_note_required: 'กรุณาระบุข้อความ',
        student_note_too_long: 'ข้อความต้องไม่เกิน 2,000 ตัวอักษร',
        save_student_note: 'บันทึกข้อความ',
        no_student_notes: 'ยังไม่มีบันทึกความจำของนักศึกษาคนนี้',
        student_note_load_failed: 'ไม่สามารถโหลดบันทึกความจำได้',
        student_note_saved: 'เพิ่มบันทึกความจำเรียบร้อยแล้ว',
        student_note_updated: 'แก้ไขบันทึกความจำเรียบร้อยแล้ว',
        student_note_deleted: 'ลบบันทึกความจำเรียบร้อยแล้ว',
        confirm_student_note_delete: 'ยืนยันการลบบันทึกความจำ',
        confirm_student_note_delete_message: 'รายการนี้จะถูกซ่อนออกจากประวัติบันทึกความจำ ยืนยันการลบหรือไม่',
    },
    english_graduate: {
        title: "ส่งผลการผ่านเกณฑ์ความรู้ภาษาอังกฤษระดับบัณฑิตศึกษา",
        title_short: "ระบบส่งผลคะแนนภาษาอังกฤษ",
        submit_english_score: "ส่งคะแนนภาษาอังกฤษ",
        officer_title_short: "ตรวจเกณฑ์ความรู้ภาษาอังกฤษ",
        student_id: "รหัสนักศึกษา",
        name: "ชื่อ",
        surname: "นามสกุล",
        admis_year: "ปีการศึกษาที่เข้า",
        level: "ระดับการศึกษา",
        curriculum_type: "ประเภทหลักสูตร",
        faculty: "คณะ / วิทยาลัย",
        curriculum: "หลักสูตร / สาขา",
        master_warning: "นักศึกษาระดับปริญญาโท กรณีลงเรียนและผ่านวิชาภาษาอังกฤษ 2 วิชา จะผ่านเกณฑ์ภาษาอังกฤษทันที โดยไม่จำเป็นต้องส่งผลเกณฑ์ความรู้ภาษาอังกฤษ",
        doctor_warning: "ที่ระดับคะแนนแรกเข้าไม่ถึงเกณฑ์ ตามที่กำหนดต้องผ่านเกณฑ์ภายใน 1 ปีนับจากปีการศึกษาที่เข้า",
        english_status: "สถานะการผ่านเกณฑ์มาตรฐานความรู้ภาษาอังกฤษ",
        english_subject: "วิชาภาษาอังกฤษ",
        check_english: "ตรวจสอบเกณฑ์คะแนนภาษาอังกฤษที่นี่",
        english_history: "ประวัติการส่งผลผ่านเกณฑ์ความรู้ภาษาอังกฤษ",
        times: "ครั้งที่",
        append_date: "วันเวลาที่ยื่น",
        criteria: "เกณฑ์ที่ยื่น",
        exam_type: "ประเภทการสอบ",
        check_status: "สถานะการตรวจ",
        approved_date: "วันเวลาที่อนุมัติ",
        approver: "ผู้อนุมัติ",
        no_record: "(ยังไม่เคยมีประวัติการส่ง)",
        open_form: "ยื่นคำขอ",
        form_title: "ฟอร์มส่งผลเกณฑ์ความรู้ภาษาอังกฤษ",
        select_criteria: "เกณฑ์สำหรับยื่น",
        select_exam: "ประเภทการสอบ",
        score: "คะแนน",
        pass_date: "วันที่สอบ",
        upload: "อัปโหลดหลักฐาน",
        submit: "ส่งผล",
        list_student: "รายชื่อผู้ส่งผลการผ่านเกณฑ์ความรู้ภาษาอังกฤษระดับบัณฑิตศึกษา",
        year: "ปีการศึกษา",
        semester: "เทอม",
        verify: "ตรวจ",
        officer_page: "หน้าคำร้องเกณฑ์ความรู้ภาษาอังกฤษ (เจ้าหน้าที่ตรวจ)",
        basic: "ข้อมูลพื้นฐาน",
        form: "ฟอร์มที่นักศึกษากรอก",
        student_english_status: "สถานะการผ่านเกณฑ์มาตรฐานความรู้ภาษาอังกฤษของนักศึกษาคนนี้",
        set_score: "มาตรฐานคะแนน",
        proof: "หลักฐาน",
        comment: "ส่วนสำหรับ Comment",
        pass: "ผ่าน",
        not_pass: "ไม่ผ่าน",
        current_status: "สถานะปัจจุบันของคำร้อง",
    },
    questionnaire: {
        title: "ประเมินแบบสอบถามความพึงพอใจ ระบบลงทะเบียนเรียน",
        title_short: "แบบสอบถาม",
        general_information: "ข้อมูลทั่วไปของผู้ตอบแบบสอบถาม",
        level_satisfaction_user: "ระดับความพึงพอใจของผู้รับบริการ",
        header_table1: "คุณลักษณะ",
        header_table2: "ระดับ (1:พึงพอใจน้อยมาก ถึง 5:พึงพอใจมากที่สุด)",
        header_table2_hint: "(โปรดให้ดาวตามระดับความพึงพอใจของท่าน)",
        Q1: "1. นักศึกษามีความรู้ความเข้าใจในระเบียบข้อบังคับที่เกี่ยวข้องกับการลงทะเบียนเรียน",
        Q2: "2. นักศึกษาได้ตรวจสอบปฏิทินการศึกษาที่สถาบันประกาศประจำปีการศึกษา ก่อนการลงทะเบียนเรียน",
        Q3: "3. นักศึกษามีความเข้าใจในการลงทะเบียนล่วงหน้า การลงทะเบียนเรียนปกติ และการเพิ่มหรือเปลี่ยนรายวิชา รวมถึงช่วงเวลาขอถอนรายวิชาตามปฏิทินการศึกษา",
        Q4: "4. ระบบการลงทะเบียนเรียนง่ายต่อการใช้งานของนักศึกษา",
        Q5: "5. เมื่อมีปัญหาหรือข้อสงสัยในการลงทะเบียนเรียน นักศึกษาสามารถติดต่อสอบถามสำนักทะเบียนในช่องทางต่างๆ ได้แก่ เพจ facebook, โทรศัพท์, หรือทางอีเมล",
        Q6: "6. ความพึงพอใจของนักศึกษาที่มีต่อการลงทะเบียนเรียนในภาพรวม",
        additional_info: "ข้อมูลเพิ่มเติม",
        additional: "ข้อเสนอแนะเพิ่มเติม / ข้อเสนอแนะอื่นๆ",
        please_rate: "โปรดให้คะแนน",
    },
    maintain: {
        title: "รักษาสภาพนักศึกษา / ลาพักการศึกษา",
        basic_info: "หากนักศึกษาต้องการรักษาสถานภาพนักศึกษาหรือลาพักการศึกษา กรุณาติดต่องานทะเบียนของคณะที่นักศึกษาสังกัด",
        basic_info_x: "หากนักศึกษาต้องการรักษาสถานภาพนักศึกษาหรือลาพักการศึกษา กรุณาติดต่องานบัณฑิตศึกษาของคณะที่นักศึกษาสังกัด",
    },
    officer: {
        config_subsidy_fee: "ตั้งค่าค่าเทอมและค่าอุดหนุนฯ",
        config_individual_tuition_fee: "ตั้งค่าเทอมนักศึกษารายบุคคล",
        report_student_not_registered: "รายงานนักเรียนที่ไม่ได้ลงทะเบียน",
    },
};
